import { Injectable, signal } from '@angular/core';
import { CheckInHealth, GeoIpEstimate, GeoOverride, ResolvedGeo } from '@/cloud/services/cloud-api.service';

export interface DeviceDetails {
    id: string;
    name?: string;
    status?: number;
    lastCheckInUtc?: string;
    appNamespaceId?: string;
    locationNodeId?: string;
    firstClaimedUtc?: string | null;
    model?: string;
    version?: string;
    packageNamespace?: string;
    payload?: any;
    tunnelConnected?: boolean;
    geoOverride?: GeoOverride | null;
    geoIp?: GeoIpEstimate | null;
    resolvedGeo?: ResolvedGeo | null;
    lastPublicIp?: string | null;
    lastPublicIpUtc?: string | null;
    /** Non-null when the cloud could not store this device's last check-in as sent. */
    checkInHealth?: CheckInHealth | null;
}

@Injectable({ providedIn: 'root' })
export class DeviceContextService {
    private _device = signal<DeviceDetails | null>(null);
    readonly device = this._device;

    setDevice(d: DeviceDetails | null) { this._device.set(d); }
}
